import { createSlice } from "@reduxjs/toolkit";
import { getReferrals, getReferralsUsers } from "../../api/referrals";

const initialState = {
  isLoading: false,
  referrals:[],
  referralUsers:[]
};

export const referralSlice = createSlice({
  name: "referral",
  initialState,
  reducers: {},
  extraReducers: {
    [getReferrals.pending]: (state) => {
      state.isLoading = true;
    },
    [getReferrals.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.referrals = payload;
    },
    [getReferrals.rejected]: (state) => {
      state.isLoading = false;
    },
    [getReferralsUsers.pending]: (state) => {
      state.isLoading = true;
    },
    [getReferralsUsers.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.referralUsers = payload;
    },
    [getReferralsUsers.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

// export const { getVariantEditedRow } = referralSlice.actions;
export const referralSelector = (state) => state.referral;
export default referralSlice.reducer;
